import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const MODULE_TITLES: Record<string, string> = {
  "owner-readiness": "mySuccession Snapshot",
  "owner-readiness-exit-timeline": "Readiness & Exit Timeline",
  "business-profile": "Business Profile",
  "business-valuation": "Business Valuation",
  "business-optimization": "Business Optimization Review",
  "advisory-team": "Advisory Team",
  "financial-readiness": "Financial Readiness",
  "successor-strategy": "mySuccession Strategy",
  "governance-family": "Governance & Family",
  "exit-structure": "Exit Structure & Tax Optimization",
  "mysuccession-plan": "mySuccession Plan Assembly",
};

interface PrerequisiteOverlayProps {
  open: boolean;
  onClose: () => void;
  lockedModuleId: string;
  incompletePrereqs: string[];
}

export function PrerequisiteOverlay({
  open,
  onClose,
  lockedModuleId,
  incompletePrereqs,
}: PrerequisiteOverlayProps) {
  const navigate = useNavigate();
  const lockedTitle = MODULE_TITLES[lockedModuleId] ?? lockedModuleId;
  const firstPrereq = incompletePrereqs[0];
  const firstPrereqTitle = MODULE_TITLES[firstPrereq] ?? firstPrereq;

  const handleGo = () => {
    onClose();
    navigate("/assessment");
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {incompletePrereqs.length === 1
              ? `Complete ${firstPrereqTitle} first`
              : `Complete prerequisites first`}
          </DialogTitle>
        </DialogHeader>

        <div className="text-sm text-muted-foreground space-y-3 py-2">
          {incompletePrereqs.length === 1 ? (
            <p>
              To unlock <span className="font-medium text-foreground">{lockedTitle}</span>,
              you need to complete{" "}
              <span className="font-medium text-foreground">{firstPrereqTitle}</span> first.
              This ensures your {lockedTitle} is built on accurate foundations.
            </p>
          ) : (
            <>
              <p>
                To unlock <span className="font-medium text-foreground">{lockedTitle}</span>,
                you need to complete the following first:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                {incompletePrereqs.map((id) => (
                  <li key={id} className="font-medium text-foreground">
                    {MODULE_TITLES[id] ?? id}
                  </li>
                ))}
              </ul>
              <p>This ensures your {lockedTitle} is built on accurate foundations.</p>
            </>
          )}
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
          <Button
            onClick={handleGo}
            className="gap-1.5 bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Go to {firstPrereqTitle} →
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
